import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface ICustomerFormMeta {
    applicationId: FormInputMeta;
    bank: FormInputMeta;
    agency: FormInputMeta;
    creationDate: FormInputMeta;
    type: FormInputMeta;
    customerId: FormInputMeta;
    vipCategory: FormInputMeta;
    solvencyLevel: FormInputMeta;
    status: FormInputMeta;
    customerParent: FormInputMeta;
    familyRelationship: FormInputMeta;
    re_AT_Parent?: FormInputMeta;
    promoter: FormInputMeta;
    enteredBy?: FormInputMeta;

    schema: any;
}

const customerFormMeta = {} as ICustomerFormMeta;

customerFormMeta.applicationId = {
    name: "applicationId",
    type: "text",
    label: "ID Application",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.bank = {
    ...CorporateNameInputMeta,
    name: "bank",
    type: "select",
    label: "Banque",
};

customerFormMeta.agency = {
    name: "agency",
    type: "select",
    label: "Agence",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.creationDate = {
    name: "creationDate",
    type: "date",
    label: "Date Application",
    placeholder: "",
    validation: yup.date().required("Champ obligatoire !"),
};

customerFormMeta.type = {
    name: "type",
    type: "select",
    label: "Type Client",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.customerId = {
    name: "customerId",
    type: "select",
    label: "ID Client",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.vipCategory = {
    name: "vipCategory",
    type: "select",
    label: "Catégorie VIP",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.solvencyLevel = {
    name: "solvencyLevel",
    type: "select",
    label: "Niveau Solvabilité",
    placeholder: "",
    validation: yup.string(),
};

customerFormMeta.status = {
    name: "status",
    type: "text",
    label: "Statut Application",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.customerParent = {
    name: "customerParent",
    type: "select",
    label: "Parent Client",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.familyRelationship = {
    name: "familyRelationship",
    type: "select",
    label: "Lien de Parenté",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.re_AT_Parent = {
    name: "re_AT_Parent",
    type: "select",
    label: "Re|AT* Parent",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.promoter = {
    name: "promoter",
    type: "select",
    label: "Promoteur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

customerFormMeta.enteredBy = {
    name: "enteredBy",
    type: "text",
    label: "Saisie par",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};


customerFormMeta.schema = yup.object().shape(getValidationSchema(customerFormMeta));

export default customerFormMeta;